import { ApiError } from "@/lib/api/error";
import { CircuitOpenError, OfflineError } from "@/lib/api/circuitBreaker";

export function isTransientQueryError(error: unknown): boolean {
  if (error instanceof OfflineError || error instanceof CircuitOpenError) {
    return true;
  }
  if (error instanceof ApiError) return error.status >= 500;
  return error instanceof TypeError;
}

export function queryRetryDelayMs(failureCount: number): number {
  const base = Math.min(250 * 2 ** failureCount, 30_000);
  return Math.round(base + Math.random() * 100);
}
